import * as React from 'react';
import styles from './left-panel.scss';
import get from 'lodash/get';

export const LeftPanel = (props) => {
  const children = React.Children.map(props.children, (child) => child);
    const wrapToNewLine = get(children[children.length-1], 'props.componentDescriptor.properties.wrapToNewLine');

    let newLine = null;
    if (wrapToNewLine) {
      newLine = children.pop();
    }
    return (<>
          <div className={styles.info}>
            {children.map((child, index) => (<span key={index}>{child} </span>))}
          </div>
          {newLine && <div className={styles.title} aria-hidden={true}>
            {newLine}
          </div>}
    </>);
};
